import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-snackbar',
  standalone: true,
  template: `
    @if(message) {
      <div class="snackbar">
        <img src="./verified.gif" alt="">
        <p>{{ message }}</p>
      </div>
    }
  `,
  styleUrls: ['./snackbar.scss']
})
export class Snackbar {
  @Input() message: string | null = null;
}
